export class LowPriorityNotificationService {

    public static id = "lowPriorityNotificationService";

    /** @ngInject */
    public constructor(private readonly growl: Growl) {
    }

    public success(title: string, content: string) {
        this.growl.success(content, {title});
    }

    public error(title: string, content: string) {
        this.growl.error(content, {title});
    }
}
